
import {getUsersList} from '../api/getUsersList';
import {setGetUsersListAction} from '../action';

const setGetUsersList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getUsersList(params);
            if (data.status === 'success') {
                dispatch(setGetUsersListAction(data.data));           
            }
    
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetUsersList
}